import React, { ReactElement } from 'react';
import { Box, styled } from '@mui/material';

const OverlayRoot = styled(Box)({
  position: 'absolute',
  inset: 0,
  borderRadius: 'inherit',
  backgroundColor: 'rgba(20, 24, 32, 0.38)',
  pointerEvents: 'all',
  zIndex: 2,
  cursor: 'not-allowed',
});

/** Covers a canvas item so other players cannot start a mutating gesture. */
export default function ItemOccupancyOverlay(): ReactElement {
  return <OverlayRoot data-testid="occupancy-overlay" aria-hidden />;
}
